import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'adm4-inventory-help-classical',
    templateUrl: './inventory-help-classical.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InventoryHelpClassicalComponent {
}
